
import React from 'react';

export const TrustIndicators: React.FC = () => {
  const indicators = [
    {
      icon: 'ri-shield-check-line',
      text: 'BBB Accredited'
    },
    {
      icon: 'ri-calendar-line',
      text: '15+ Years Experience'
    },
    {
      icon: 'ri-building-line',
      text: 'In any condition'
    },
    {
      icon: 'ri-map-pin-line',
      text: '50 States Served'
    },
    {
      icon: 'ri-star-fill',
      text: '4.9/5 Rating'
    }
  ];

  return (
    <section className="bg-gray-100 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16">
          {indicators.map((indicator, index) => (
            <div key={index} className="flex flex-col items-center text-center">
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mb-4">
                <i className={`${indicator.icon} text-white text-2xl`}></i>
              </div>
              <div className="text-gray-800 font-semibold">{indicator.text}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
